export const showConfirm = ({ title, message, confirmText = 'Confirm', iconClass = 'bi-question-circle' }) => {
    return new Promise((resolve) => {
        const overlay = document.createElement('div');
        overlay.className = 'confirm-overlay';
        overlay.innerHTML = `
            <div class="confirm-dialog">
                <div class="confirm-icon"><i class="bi ${iconClass}"></i></div>
                <h4 class="confirm-title">${title}</h4>
                <p class="confirm-message">${message}</p>
                <div class="confirm-actions">
                    <button class="confirm-btn-cancel">Cancel</button>
                    <button class="confirm-btn-ok">${confirmText}</button>
                </div>
            </div>
        `;

        const close = (result) => {
            overlay.remove();
            resolve(result);
        };

        overlay.querySelector('.confirm-btn-cancel').addEventListener('click', () => close(false));
        overlay.querySelector('.confirm-btn-ok').addEventListener('click', () => close(true));
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(false); });

        document.body.appendChild(overlay);
    });
};

export const utils = {
    formatDate(dateString) {
        const topicDate = new Date(dateString + "T00:00:00");
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const tomorrow = new Date(today);
        tomorrow.setDate(today.getDate() + 1);


        if (topicDate.getTime() === today.getTime()) {
            return "Today";
        } else if (topicDate.getTime() === tomorrow.getTime()) {
            return "Tomorrow";
        }

        // If not today or tomorrow, use standard format
        return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric'
        }).format(topicDate);
    },
    isMobile() {
        return window.innerWidth < 992;
    }
};